import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth-service';
import { registerDatabase } from '@firebase/database';
import { Task } from '../models/task';
import { DataSnapshot } from '@firebase/database-types';
import { TaskDetails } from '../models/task-details';

@Injectable()
export class TasksServices {
    data = [];
    constructor(private db: AngularFireDatabase, private authService: AuthService) {

    }

    getTasks(): Task[] {
        const username = this.authService.getUserId();
        // tslint:disable-next-line:prefer-const
        let tasksList: Task[] = [];
        this.db.database.ref('tasks').orderByChild('userCode').equalTo(username).limitToLast(5)
        .once('value')
        .then((snapshot: DataSnapshot) => {
            snapshot.forEach((childSnapshot) => {
                // console.log(  new Date(childSnapshot.val().createDate).getTime());

                tasksList.push({code: childSnapshot.key, createDate: childSnapshot.val().createDate
                        , description: childSnapshot.val().description, comments : childSnapshot.val().comments
                        , finished : childSnapshot.val().finished, updated: childSnapshot.val().updated
                        , updatedDate: childSnapshot.val().updatedDate, userName : childSnapshot.val().userName});
                return false;
            });
            tasksList =  tasksList.reverse();
        });


        return tasksList;
    }

    getAllTasks(): TaskDetails[] {
        // tslint:disable-next-line:prefer-const
        let tasksList: Task[] = [];
        let username = '';
        // tslint:disable-next-line:prefer-const
        let details: TaskDetails[] = [];
        this.db.database.ref('tasks').orderByChild('userCode')
        .once('value')
        .then((snapshot: DataSnapshot) => {
            let cont = 0;
            snapshot.forEach((childSnapshot) => {
                cont ++;
                if (username === '') {
                    username = childSnapshot.val().userName;
                }

                if (username !== childSnapshot.val().userName) {
                    details.push({userName : username, userTasks: tasksList.reverse()});
                    username = childSnapshot.val().userName;
                    tasksList = [];
                }

                tasksList.push({code: childSnapshot.key, createDate: childSnapshot.val().createDate
                    , description: childSnapshot.val().description, comments : childSnapshot.val().comments
                    , finished : childSnapshot.val().finished, updated: childSnapshot.val().updated
                    , updatedDate: childSnapshot.val().updatedDate, userName : childSnapshot.val().userName});

                if (snapshot.numChildren() === cont) {
                    details.push({userName : username, userTasks: tasksList.reverse()});
                }

                return false;
            });

        });

        return details;
    }

    CreateNew(task: Task) {
        const username = this.authService.getUserId();
        const savedData = this.db.list('tasks');
        savedData.push({ description: task.description, createDate: task.createDate.toISOString()
        , comments: task.comments, finished: task.finished, userName: this.authService.getUserName()
        , userCode: this.authService.getUserId()});

    }

    Update(task: Task) {
        const username = this.authService.getUserId();
        const savedData = this.db.list('tasks');
        savedData.update('/' + task.code, task);
    }
}



// WEBPACK FOOTER //
// ./src/app/tasks/tasks-services.ts